module.exports = __webpack_public_path__ + "static/img/kpicon-video.7f3850be.svg";